import './sharingGroups.scss';

import React from 'react';
import BbInput from '../styling/bbInput';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Widget from '../common/widget';
import { Formik, Form } from 'formik';
import ResponsiveTable from '../layoutItems/responsiveTable';
import { apiGet, getHostApi, apiPost, apiDelete } from '../../store/apiWrapper';
import Message from '../common/message';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popupActions } from '../../store/popupStore';
import { Circles } from '../common/loadingComponent';
import BbDeleteIcon from '../../img/icons/BBiconsOdstranit';
import SvgUpravit from '../../img/icons/Upravit';

class SharingGroups extends React.Component {
    mounted = true;

    state = {
        groups: null, groupsLoading: false, groupsError: null, initialForm: { name: '' },
        groupAdding: false, groupAddingError: null,
        groupDeleting: false, groupDeletingError: null
    };

    componentDidMount() {
        this.setState({ groups: null, groupsError: null, groupsLoading: true });
        apiGet(`${getHostApi()}/api/account/sharing-groups`, null,
            res => this.mounted && this.setState({ groups: res.data, groupsLoading: false }),
            _ => this.mounted && this.setState({ groupsError: this.props.translate('Common.Error'), groupsLoading: false })
        );
    }

    componentDidUpdate() {
        if (this.state.initialForm.name === ' ') {
            // workaround to force reinitialize adding form
            this.setState({ initialForm: { name: '' } });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <div className='content-root sharing-groups-content-root'>
                <Widget
                    className='widget' hideHeader
                    isLoading={this.state.groupsLoading || this.state.groupDeleting} initialExpanded={true}
                >
                    <div className='columns'>
                        <div className='column' style={{ textAlign: 'right' }}>
                            <button
                                className={classnames(
                                    'bb-button bold-bb-button is-primary gradient-1',
                                    { 'disabled': this.state.groupsLoading || this.state.groupAdding || !this.state.groups },
                                    { 'is-square': localStorage.locales_button_style === 'square' }
                                )}
                                disabled={this.state.groupsLoading || this.state.groupAdding || !this.state.groups}
                                onClick={() => this.addGroup()}
                            >
                                <Translate id='User.SharingGroups.AddGroup' />
                            </button>
                        </div>
                    </div>

                    {(this.state.groupsLoading || this.state.groupDeleting) ? <Circles /> : <>
                        {this.state.groupsError && <><Message type='error' message={this.state.groupsError} /><br /></>}
                        {this.state.groupDeletingError && <><Message type='error' message={this.state.groupDeletingError} /><br /></>}
                        {!this.state.groupsError && !this.state.groupsLoading && (!Array.isArray(this.state.groups) || this.state.groups.length < 1) &&
                            <p>{this.props.translate('User.SharingGroups.NoGroupFound')}</p>
                        }
                        {Array.isArray(this.state.groups) && this.state.groups.length > 0 &&
                            <div className="columns is-centered" style={{ flexDirection: "column", margin: 0 }}>
                                <ResponsiveTable>
                                    <table className='table table-report-section'>
                                        <thead>
                                            <tr>
                                                <th><Translate id='Common.Title' /></th>
                                                <th className='align-right pr-05' ><Translate id='User.SharingGroups.UsersCount' /></th>
                                                <th className='fitwidth align-right'><Translate id='Common.Actions' /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.groups.sort((g1, g2) => g1.title.localeCompare(g2.title)).map(g => (
                                                <tr className='colorize' key={g.id}>
                                                    <td data-label={this.props.translate('Common.Title')}><span>{g.title}</span></td>
                                                    <td className='align-right  pr-05' data-label={this.props.translate('User.SharingGroups.UsersCount')}>
                                                        <span>{g.usersCount}</span>
                                                    </td>
                                                    <td className='fitwidth' data-label={this.props.translate('Common.Actions')}>
                                                        <span className='delete-update-links'>
                                                            <Link className="link-internal" to={`${this.props.match.url}/${g.id}`}>
                                                                <SvgUpravit className='svg-standard-fill' />
                                                                <span><Translate id='Common.Button.Update' /></span>
                                                            </Link>
                                                            <a className="link-internal" onClick={_ => this.deleteGroup(g.id)}>
                                                                <BbDeleteIcon className='svg-standard-fill' />
                                                                <span><Translate id='Common.Button.Delete' /></span>
                                                            </a>
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </ResponsiveTable>
                            </div>
                        }
                    </>}
                </Widget>
            </div>
        )
    }

    addGroup = () => {
        this.props.showPopup('sharingGroupAddGroupPopup',
            {
                open: true,
                title: this.props.translate('User.SharingGroups.AddGroup'),
                close: this.props.hidePopup,
                add: (title) => {
                    this.props.hidePopup();
                    this.setState({ groupAdding: true, groupAddingError: null });
                    apiPost(
                        `${getHostApi()}/api/account/sharing-groups`, null, title,
                        res => this.mounted && this.setState(state => ({
                            groupAdding: false,
                            initialForm: { name: ' ' },
                            groups: state.groups.concat([{ id: res.data, title: title, usersCount: 0 }])
                        })),
                        _ => this.mounted && this.setState({ groupAdding: false, groupAddingError: this.props.translate('Common.Error') })
                    );
                }
            });
    }

    deleteGroup = id => {
        this.props.showPopup('sharingGroupRemovalConfirmation',
            {
                open: true,
                title: this.props.translate('Common.Warning'),
                close: this.props.hidePopup,
                no: this.props.hidePopup,
                yes: () => {
                    this.props.hidePopup();
                    this.setState({ groupDeleting: true, groupDeletingError: null });
                    apiDelete(
                        `${getHostApi()}/api/account/sharing-groups/${id}`, null, null,
                        _ => this.mounted && this.setState(state => ({
                            groupDeleting: false,
                            groups: state.groups.filter(g => g.id !== id)
                        })),
                        _ => this.mounted && this.setState({ groupDeleting: false, groupDeletingError: this.props.translate('Common.Error') })
                    );
                }
            })
    }

    isWorking = () => this.state.groupsLoading || this.state.groupAdding || this.state.groupDeleting;
}

export default withLocalize(withRouter(connect(
    state => state.popup, dispatch => bindActionCreators(popupActions, dispatch)
)(SharingGroups)));